import React, { useState, useEffect } from "react";
import "./StockTicker.css";
import { stockData } from "../services/stockData.js";

const StockTicker = () => {
  const [stocks, setStocks] = useState([]);

  // useEffect(() => {
  //   let timeout;
  //   const fetchData = async () => {
  //     const ticker = await stockData();
  //     console.log(ticker.data, "a");
  //     setStocks(ticker.data);

  //     const isEnd = ticker.data?.length === 0 || ticker.endReached;

  //     if (isEnd) {
  //       // If end, try again after 3 seconds
  //       timeout = setTimeout(fetchData, 6000);
  //     }
  //   };

  //   fetchData(); // initial fetch on mount

  //   return () => {
  //     clearTimeout(timeout); // cleanup on unmount
  //   };
  // }, []);

  // Create a duplicate set of stocks to ensure seamless infinite scrolling
  const duplicatedStocks = [...stocks, ...stocks, ...stocks];

  return (
    <div className="stock-ticker-container">
      {stocks.length > 0 && (
        <div className="stock-ticker-wrapper">
          <div className="stock-ticker">
            {duplicatedStocks.map((stock, index) => (
              <div className="stock-item" key={`${stock?.SYMBOL}-${index}`}>
                <span className="stock-symbol">{stock?.SYMBOL}</span>
                <span className="stock-price">
                  {stock.PRICE} / {(stock.VOLUME / 1_000_000).toFixed(2) + "M"}
                </span>
                <span
                  className={`stock-change ${
                    stock?.COLOR === "RED" ? "negative" : "positive"
                  }`}
                >
                  {stock.CHANGE}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default StockTicker;